import { isLocalhost } from '../serviceWorker';

export const rootUrl = isLocalhost
  ? 'http://localhost:3000/'
  : 'https://preview-firebase.reactmilkshake.com/';

export const firebaseConfig = {
  apiKey: 'AIzaSyCKMZLbC136CdcNXG0yCL9oIHpWkbcOUGI',
  authDomain: 'react-milkshake.firebaseapp.com',
  databaseURL: 'https://react-milkshake.firebaseio.com',
  projectId: 'react-milkshake',
  storageBucket: 'react-milkshake.appspot.com',
  messagingSenderId: '22333579706',
  appId: '1:22333579706:web:8830496e32c32b7c3afd83'
};

export const messageTypes = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO'
};
